import { makeStyles } from '@material-ui/styles';
import { toolbarMinHeight } from '../../service/constants';
import { darkFullWhite } from '../../service/getMuiThemeStyle';

export const useStyles = makeStyles((theme) => ({
    acceptBtn: {
        position: 'fixed',
        right: '20px',
        bottom: '20px',
        zIndex: theme.zIndex.drawer + 2,
    },
    appBar: {
        display: 'flex',
        zIndex: theme.zIndex.drawer + 2,
    },
    content: {
        position: 'fixed',
        top: toolbarMinHeight,
        bottom: 0,
        right: 0,
        left: 0,
        marginTop: '3px',
        paddingBottom: 50,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        zIndex: theme.zIndex.drawer + 1,

        fontFamily: theme.fontFamily,
        fontSize: '18px !important',

        backgroundColor: theme.paper.backgroundColor,
        color: theme.palette.textColor,

        overflowY: 'scroll',
        '-webkit-overflow-scrolling': 'touch',
        transition: 'all 195ms cubic-bezier(0.4, 0.0, 1, 1)',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        userSelect: 'none',

        ['@media only screen and (max-device-width: 1024px) and (orientation: portrait)']: {
            fontSize: '16px !important',
        },

        [theme.breakpoints.down('xs')]: {
            top: 48,
        },
    },
    container: {
        padding: 0,
    },
    image: {
        display: 'block',
        margin: 'auto',
        padding: theme.spacing(1),
        width: '100%',
    },
    title: {
        marginLeft: theme.spacing(1),
        marginRight: 'auto',

        fontSize: '20px',
        color: darkFullWhite,
    },
    toolbar: {
        paddingLeft: 4,
        paddingRight: theme.spacing(1),
    },
}));
